// import DateTimeWidget from "./DateTimeWidget.js"
import TermAndConditionWidget from "./TermConditionWidget.js"

// import SingleChoiceWidget from "./SingleChoiceWidget.js"
// import SingleTextWidget from "./SingleTextWidget.js"
// import DateWidget from "./DateWidget.js"
// import DropdownWidget from "./DropdownWidget.js"
// import EmailWidget from "./EmailWidget.js"
// import FileUploadWidget from "./FileUploadWidget.js"
// import MultiChoiceWidget from "./MultiChoiceWidget.js"
// import TelWidget from "./TelWidget.js"
// import NumberWidget from "./NumbericWidget.js"
// import TimeWidget from "./TimeWidget.js"
// import MultipleTextWidget from "./MultipleTextWidget.js"


import EmailWidget from "./email/Email.widget.js"
import DateWidget from "./date/Date.widget.js"
import SingleTextWidget from "./single-text/SingleText.widget.js"
import FileUploadWidget from "./fileupload/FileUpload.widget.js"
import DropdownWidget from "./dropdown/Dropdown.widget.js"
import SingleChoiceWidget from "./single-choice/SingleChoice.widget.js"
import MultiChoiceWidget from "./multiple-choice/MultiChoice.widget.js"
import TelWidget from "./tel/Tel.widget.js"
import NumberWidget from "./number/Numberic.widget.js"
import TimeWidget from "./time/Time.widget.js"
import DateTimeWidget from "./datetime/Datetime.widget.js"
import MultipleTextWidget from "./multiple-text/MultipleText.widget.js"

const NewWidget = (() => {
    const widgets = {
        'drop_down': DropdownWidget,
        'numeric': NumberWidget,
        'number': NumberWidget,
        'mail': SingleTextWidget,
        'single_choice': SingleChoiceWidget,
        'long_answer': MultipleTextWidget,
        'multi_choice': MultiChoiceWidget,
        'date': DateWidget,
        'time': TimeWidget,
        'datetime': DateWidget,
        'short_answer': SingleTextWidget,
        'rich_text_editor': MultipleTextWidget,
        'email': EmailWidget,
        'tel': TelWidget,
        'term_and_condition': TermAndConditionWidget,
        'file': FileUploadWidget
    }
    /**
     * @param { string } type
     * @param {FieldModel} mField
     * @return {TaiBaseWidget}
     */
    return (type, mField) => new widgets[type](mField);
})();

export {
    SingleTextWidget,
    MultipleTextWidget,
    NumberWidget,
    MultiChoiceWidget,
    SingleChoiceWidget,
    DropdownWidget,
    DateWidget,
    TimeWidget,
    DateTimeWidget,
    EmailWidget,
    TelWidget,
    TermAndConditionWidget,
    FileUploadWidget,
    NewWidget
}

